export default __webpack_public_path__ + "static/media/section3-img2.dc85030e.png";